import "./FreeEsimTrialBanner.scss";

import { useTranslation } from "react-i18next";

import { FreeEsimTrialTooltip } from "@/components/Onboarding/Steps/RateSelection/FreeEsimTrialTooltip/FreeEsimTrialTooltip";

export const FreeEsimTrialBanner = () => {
  const { t } = useTranslation();

  return (
    <div id="esim-trial-banner-box">
      <p className="text-xl font-semibold text-white">
        {t("translation:Onboarding.sections.rate-selection.esimBannerIntro")}
      </p>
      <div className="flex flex-row items-center justify-center gap-2">
        <p className="text-2xl font-semibold text-primary-100">
          {t("translation:Onboarding.sections.rate-selection.esimBannerTitle")}
        </p>
        <FreeEsimTrialTooltip />
      </div>
    </div>
  );
};
